import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import menu from './menu';
import VerticalNav from '@component/navigation/verticalnav';
import I18n from '@module/i18n';
import Checkbox from '@component/form/element/checkbox';
import { CcpaLegalText } from '../../component/ccpa/ccpa-legal-text';
import { track } from '@module/consent-manager/tracker';
import { isConsentFlagActive } from '@component/consent-manager/flags';

import {
  accept,
  reject,
  getCcpaCookieState,
} from '@module/consent-manager/ccpa-manager';

export const CcpaPreferences = ({ path, region }) => {
  const [isCcpaChecked, setCcpaChecked] = useState(getCcpaCookieState());

  useEffect(() => {
    if (!isCcpaChecked) {
      setCcpaChecked(false);
      track({
        category: 'cmp',
        action: 'reject_ccpa',
      });
      return reject();
    }

    setCcpaChecked(true);

    track({
      category: 'cmp',
      action: 'accept_ccpa',
    });

    accept();
  }, [isCcpaChecked]);

  const handleCcpaOnChange = () => {
    setCcpaChecked(!isCcpaChecked);
  };

  return (
    <div className="ccpa-page legal--cookies row legal">
      <div className="legal__nav-col">
        <VerticalNav
          items={menu(region.country, isConsentFlagActive())}
          activeItem={path}
        />
      </div>

      <div className="ccpa-preferences__container">
        <h1 className="ccpa-preferences__title">
          {I18n.t('transfer.consent-manager.ccpa-header')}
        </h1>

        <div className="ccpa-preferences__intro">
          {I18n.t('transfer.consent-manager.ccpa-intro')}
        </div>

        <div>
          <Checkbox
            onChange={handleCcpaOnChange}
            name="ccpa-check"
            label={I18n.t('transfer.consent-manager.ccpa-donotsell')}
            checked={isCcpaChecked}
            size="small"
          />
        </div>
        <div>
          <CcpaLegalText />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ route, session: { region } }) => ({
  path: route.path,
  region,
});

export default connect(mapStateToProps)(CcpaPreferences);

CcpaPreferences.propTypes = {
  path: PropTypes.string.isRequired,
  language: PropTypes.string,
  region: PropTypes.object,
};
